<script setup lang="ts">
import IconButton from '@/uiKit/IconButton.vue'
import ModalDialog from '@/uiKit/ModalDialog.vue'

const open = defineModel<boolean>({ required: true })
</script>

<template>
  <ModalDialog
    :open="open"
    class="overflow-hidden bg-surface-popover shadow-lg"
    @close="open = false"
  >
    <div class="flex h-[560px] flex-row">
      <form
        class="flex w-[480px] max-w-lg flex-col justify-between p-8"
        @submit.prevent
      >
        <div class="flex flex-col gap-6">
          <!-- Dialog title and description -->
          <slot name="header" />

          <!-- Form fields -->
          <slot name="form" />
        </div>

        <!-- Actions -->
        <div class="flex gap-2">
          <slot name="actions"> </slot>
        </div>
      </form>

      <aside class="relative w-[480px] bg-surface-tertiary-persist">
        <IconButton
          size="lg"
          rounded
          variant="neutral"
          class="absolute top-4 right-4"
          icon="close"
          @click="open = false"
        />
        <slot name="aside" />
      </aside>
    </div>
  </ModalDialog>
</template>
